import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { API, axios } from '../../utils/api';
import { daIso, GIORNI_BREVI } from '../../utils/agenda';
import { dichiarazioneAgenzia, euro } from '../../utils/scheda';
import { giornoEMese, leggiDataUtc, linkChiama } from '../../utils/percorso';
import Icona from '../cliente/Icone';
import EsitoTelefonata from '../staff/EsitoTelefonata';
import { ConsiglioRiga } from '../staff/Consiglio';
import { Spunta } from '../staff/CardVoce';
import CosaVoce from '../staff/CosaVoce';
import { DisponibilitaStaff, Feed, NoteInterne } from './comuni';

// Scheda "Panoramica" della scheda cliente: "Adesso" (le cose aperte nel formato cosa / per chi / su cosa, con il
// consiglio sotto), "La ricerca" con sotto la griglia della disponibilità, gli immobili che contano; a destra azioni
// rapide, note interne, ultime novità con l'iniziale di chi (il cliente in grigio).

const TAG = { visita_richiesta: ['t-g', 'visita richiesta'], documenti: ['t-b', 'documenti'] };

const RigaAdesso = ({ a, onCambia, isAdmin, vaiA }) => {
  const [esito, setEsito] = useState(false);
  if (a.tipo === 'voce') {
    const v = a.voce;
    const d = daIso(v.data);
    const telefonata = v.tipo === 'telefonata';
    return (
      <div>
        <div className="h">{d.getDate()}<small>{GIORNI_BREVI[d.getDay()]}{v.ora ? ` ${v.ora}` : ''}</small></div>
        <div style={{ minWidth: 0 }}>
          {v.cosa ? <CosaVoce cosa={v.cosa} tipo={v.tipo} voce={v} /> : <b>{v.titolo}</b>}
          <span>{[v.assegnata?.nome ? `la fa ${v.assegnata.nome}` : null, v.cosa ? null : v.note, v.in_ritardo ? 'in ritardo' : null].filter(Boolean).join(' · ')}</span></div>
        <div className="azioni">
          {telefonata && (v.immobile_id || v.agenzia_id) && <button type="button" className="btn sm p" onClick={() => setEsito(!esito)}>Esito</button>}
          {!telefonata && v.immobile_id && <Link className="btn sm" to={`/immobili/${v.immobile_id}`}>Apri</Link>}
          {!telefonata && !v.immobile_id && v.tipo === 'documento' && <button type="button" className="btn sm" onClick={() => vaiA('documenti')}>Apri</button>}
          <Spunta voce={v} onCambia={onCambia} />
        </div>
        {v.consiglio && <ConsiglioRiga consiglio={v.consiglio} onFatto={onCambia} />}
        {esito && <div style={{ gridColumn: '1/-1' }}><EsitoTelefonata voce={v} isAdmin={isAdmin} onFatto={() => { setEsito(false); onCambia(); }} /></div>}
      </div>
    );
  }
  const [classe, etichetta] = TAG[a.tipo] || ['t-o', a.tipo];
  const tel = a.tipo === 'visita_richiesta' && linkChiama(a.agenzia?.telefono);
  const voceChiamata = a.tipo === 'visita_richiesta' ? { id: `sug:chiama:${a.immobile?.id}`, tipo: 'telefonata', immobile_id: a.immobile?.id, agenzia_id: a.agenzia?.id, cliente_id: null } : null;
  return (
    <div>
      <span className={`tag ${classe}`}>{etichetta}</span>
      <div style={{ minWidth: 0 }}>{a.cosa ? <CosaVoce cosa={a.cosa} tipo={a.tipo} voce={a} /> : <><b>{a.titolo}</b><span>{a.dettaglio}</span></>}</div>
      <div className="azioni">
        {tel && <a className="btn sm p" href={tel}>Chiama {a.agenzia?.nome?.split(' ')[0]}</a>}
        {a.tipo === 'visita_richiesta' && <button type="button" className="btn sm" onClick={() => setEsito(!esito)}>Esito</button>}
        {a.tipo === 'documenti' && <button type="button" className="btn sm" onClick={() => vaiA('documenti')}>Apri</button>}
      </div>
      {a.consiglio && <ConsiglioRiga consiglio={a.consiglio} onFatto={onCambia} />}
      {esito && voceChiamata && <div style={{ gridColumn: '1/-1' }}><EsitoTelefonata voce={{ ...voceChiamata, cliente_id: a.cliente_id }} isAdmin={isAdmin} onFatto={() => { setEsito(false); onCambia(); }} /></div>}
    </div>
  );
};

// "385.000 € · 92 m² · ● Ermes" (il pallino è la dichiarazione dell'agenzia: verde dichiarata, arancio in attesa,
// rosso non dichiara — lo stesso colore che si vede accanto alle case altrove)
const MetaImmobile = ({ i }) => {
  const pezzi = [euro(i.prezzo) && <b key="p">{euro(i.prezzo)}</b>, i.superficie,
    i.agenzia_nome && <span key="ag" className="ag" title={dichiarazioneAgenzia(i.agenzia_dichiarazione).testo}>
      <i style={{ background: dichiarazioneAgenzia(i.agenzia_dichiarazione).colore }} />{i.agenzia_nome}</span>].filter(Boolean);
  return <div className="m">{pezzi.reduce((acc, x, n) => (n ? [...acc, ' · ', x] : [x]), [])}</div>;
};

// Le azioni rapide: le stesse del menu "+ Azione" (Nuova proposta e Messaggio solo per l'admin)
export const AzioniRapide = ({ apri, vaiA, isAdmin }) => (
  <section className="card r">
    <div className="ttl"><div className="i w"><Icona nome="piu" /></div><h2>Azioni rapide</h2></div>
    <div className="qa">
      <button type="button" className="p" onClick={() => apri('link')}>Proponi un immobile</button>
      <button type="button" onClick={() => vaiA('documenti')}>Chiedi documenti</button>
      <button type="button" onClick={() => apri('visita')}>Fissa una visita</button>
      {isAdmin && <button type="button" onClick={() => apri('proposta')}>Nuova proposta</button>}
      <button type="button" onClick={() => apri('nota')}>Aggiungi nota</button>
      {isAdmin && <button type="button" onClick={() => apri('messaggio')}>Invia messaggio</button>}
    </div>
  </section>
);

// I prospetti del mutuo collegati a questo cliente. **Solo admin**: la rotta risponde 403 a tutti gli altri
// (backend/mutui.py), quindi al collaboratore questo riquadro non si chiede nemmeno. Da qui non si modifica
// niente: si legge e si apre il prospetto in Mutui.
export const ProspettiMutuo = ({ clienteId }) => {
  const [prospetti, setProspetti] = useState([]);
  useEffect(() => {
    let vivo = true;
    axios.get(`${API}/clienti/${clienteId}/prospetti-mutuo`)
      .then((r) => { if (vivo) setProspetti(r.data?.prospetti || []); })
      .catch(() => {});
    return () => { vivo = false; };
  }, [clienteId]);
  if (!prospetti.length) return null;
  return (
    <section className="card r" data-testid="prospetti-mutuo">
      <div className="ttl"><div className="i"><Icona nome="euro" /></div><h2>Prospetti mutuo <small>{prospetti.length}</small></h2>
        <Link className="link" to="/admin/mutui">Mutui →</Link></div>
      <div className="rows">
        {prospetti.map((p) => (
          <div key={p.id}>
            <div style={{ minWidth: 0 }}>
              <b>{p.titolo}</b>
              <span>{euro(Math.round(p.rata_massima))}/mese · mutuo fino a {euro(p.importo_mutuo_mostrato)} · {giornoEMese(leggiDataUtc(p.aggiornato_il))}</span>
            </div>
            <Link className="btn sm" to={`/admin/mutui/${p.id}`}>Apri</Link>
          </div>
        ))}
      </div>
    </section>
  );
};

const TabPanoramica = ({ scheda, onCambia, isAdmin, vaiA, apri }) => (
  <div className="g2">
    <div className="stack">
      <section className="card hero r" data-testid="adesso">
        <div className="ttl"><div className="i"><Icona nome="orologio" /></div><h2>Adesso</h2></div>
        <div className="rows">
          {!scheda.adesso.length && <p className="vuoto">Niente di aperto su questo cliente.</p>}
          {scheda.adesso.map((a, i) => <RigaAdesso key={a.voce?.id || `${a.tipo}-${i}`} a={{ ...a, cliente_id: scheda.cliente.id }} onCambia={onCambia} isAdmin={isAdmin} vaiA={vaiA} />)}
        </div>
      </section>
      <section className="card r" data-testid="la-ricerca">
        <div className="ttl"><div className="i"><Icona nome="luogo" /></div><h2>La ricerca</h2><button type="button" className="link" onClick={() => apri('ricerca')}>Modifica</button></div>
        <div className="kv">
          {scheda.ricerca.map((k) => <div key={k.etichetta}><small>{k.etichetta}</small><b className={k.valore ? undefined : 'vuoto'}>{k.valore || '—'}</b></div>)}
        </div>
      </section>
      <DisponibilitaStaff clienteId={scheda.cliente.id} nome={scheda.cliente.nome} />
      <section className="card r" data-testid="immobili-che-contano">
        <div className="ttl"><div className="i b"><Icona nome="immobili" /></div><h2>Immobili <small>{scheda.conteggi.immobili_attivi} attivi · {scheda.conteggi.in_trattativa} in trattativa</small></h2><button type="button" className="link" onClick={() => vaiA('immobili')}>Tutti →</button></div>
        {!scheda.importanti.length && <p className="vuoto">Nessun immobile attivo.</p>}
        {scheda.importanti.map((i) => (
          <div className="prop" key={i.id}>
            {i.foto ? <img className="im" src={i.foto} alt="" /> : <div className="im" />}
            <div style={{ minWidth: 0 }}>
              <h4>{i.titolo || i.indirizzo}</h4>
              <MetaImmobile i={i} />
              {i.proposta && <span className="tag t-o" style={{ marginTop: '.3rem' }}>Proposta {i.proposta.offerto} · {i.proposta.stato === 'inviata' ? 'in attesa' : i.proposta.stato.replace('_', ' ')}</span>}
              {!i.proposta && i.visita_richiesta && <span className="tag t-g" style={{ marginTop: '.3rem' }}>Visita richiesta dal cliente</span>}
            </div>
            <div className="acts">
              {i.visita_richiesta ? <button type="button" className="btn sm p" onClick={() => apri('visita', i.id)}>Fissa visita</button> : <Link className="btn sm" to={`/immobili/${i.id}`}>Apri</Link>}
            </div>
          </div>
        ))}
      </section>
    </div>
    <div className="stack">
      <AzioniRapide apri={apri} vaiA={vaiA} isAdmin={isAdmin} />
      {isAdmin && <ProspettiMutuo clienteId={scheda.cliente.id} />}
      <NoteInterne clienteId={scheda.cliente.id} note={scheda.note} onFatto={onCambia} />
      <section className="card r">
        <div className="ttl"><div className="i"><Icona nome="orologio" /></div><h2>Ultime novità</h2><button type="button" className="link" onClick={() => vaiA('cronologia')}>Tutto →</button></div>
        <Feed voci={scheda.novita.slice(0, 6)} />
      </section>
    </div>
  </div>
);

export default TabPanoramica;
